import { useDataProvider } from "ra-core";
import type { EmailDataProvider, EmailMethods } from "./types";

/** The dataProvider's custom email methods (FakeRest in demo/tests, RPCs + edge functions on Supabase). */
export function useEmailApi(): EmailMethods {
  const dp = useDataProvider<EmailDataProvider>();
  if (typeof dp.emailPreviewSegment !== "function")
    throw new Error("EmailMethods missing on the dataProvider");
  return dp;
}
